/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import ThreeJSDemo from '../interactive/ThreeJSDemo.js';
export const metadata = {
  demo: ThreeJSDemo,
  title: 'ThreeJS Basics'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`For the workshop, we'll be using `}<a parentName="p" {...{
        "href": "https://threejs.org/"
      }}>{`ThreeJS`}</a>{` as the rendering engine on top of WebGL and GLSL.`}</p>
    <p>{`Some helpful links:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/docs/"
        }}>{`Docs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org/examples/"
        }}>{`Examples`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mrdoob/three.js/"
        }}>{`Github`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
